export enum RecommendationSource {
  Partner = 'partner',
  InApp = 'inApp',
  Public = 'public',
  Mock = 'mock',
}
